"use client";

import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
import React from "react";

type ListingScrollableWrapperProps = {
  children: React.ReactNode;
  asidePosition?: "left" | "right";
};

export const ListingScrollableWrapper = ({
  children,
  asidePosition = "left",
}: ListingScrollableWrapperProps) => {
  return (
    <aside
      className={cn(
        "basis-76 hidden shrink-0 self-start lg:block sticky top-28 h-[calc(100dvh-115px)]",
        asidePosition === "right" ? "order-3" : "order-1"
      )}
    >
      <ScrollArea className="h-full">
        {children}
        <ScrollBar orientation="vertical" />
      </ScrollArea>
    </aside>
  );
};
